import { render, staticRenderFns } from "./PlanSummary.vue?vue&type=template&id=65a62341&scoped=true&"
import script from "./PlanSummary.vue?vue&type=script&lang=ts&"
export * from "./PlanSummary.vue?vue&type=script&lang=ts&"
import style0 from "./PlanSummary.vue?vue&type=style&index=0&id=65a62341&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a62341",
  null
  
)

export default component.exports